/* eslint-disable camelcase */
import React from 'react'
import { bool, func, shape } from 'prop-types'
import { Link } from 'react-router-dom'

import { FormattedDate, FormattedTime } from 'react-intl'
import { mapContextToFilter } from '../dashboard-utils'
import { qlqGenericDataQuery } from 'crm-data/generic-data'
import { CrmModal } from 'crm-components'
import genericTableFactory from 'crm-components/ql/table/crm-generic-ql-table.jsx'

const columns = [
  {
    Header: 'Account Name',
    Cell: row => (
      <Link to={'/crm/account/' + row.original.account_uid} target="blank">
        {row.original.name}
      </Link>
    ),
    accessor: 'name'
  },
  {
    Header: 'Kind',
    accessor: 'kind'
  },
  {
    Header: 'Step',
    accessor: 'sales_step_code'
  },
  {
    Header: 'Owner User',
    accessor: 'owner_user__full_name'
  },
  {
    Header: 'Lead Campaign',
    accessor: 'lead_campaign__name'
  },
  {
    Header: 'Sales Campaign',
    accessor: 'sales_campaign__name'
  },
  {
    Header: 'Lead In Date',
    accessor: 'lead_in_date',
    Cell: row =>
      row.original.lead_in_date ? (
        <span>
          <FormattedDate value={row.original.lead_in_date} />{' '}
          <FormattedTime value={row.original.lead_in_date} />
        </span>
      ) : (
        <span />
      )
  },
  {
    Header: 'Pipeline Type',
    accessor: 'process_type_name'
  },
  {
    Header: 'Pipeline step',
    accessor: 'process_step_name'
  },
  {
    Header: 'Opportunity Size',
    accessor: 'opportunity_size'
  },
  {
    Header: 'Last Activity Date',
    accessor: 'last_activity_date',
    Cell: row =>
      row.original.last_activity_date ? (
        <span>
          <FormattedDate value={row.original.last_activity_date} />{' '}
          <FormattedTime value={row.original.last_activity_date} />
        </span>
      ) : (
        <span />
      )
  }
]
const qlOptions = {
  options: ownProps => {
    console.log('qlOtions, ', ownProps)
    const props = { analyticsContext: { filters: ownProps.filters } }
    const filter = { ...ownProps.filters, ...mapContextToFilter(props) }

    return {
      variables: {
        filter,
        fields: [
          'account_uid',
          'name',
          'kind',
          'sales_step_code',
          'owner_user__full_name',
          'lead_campaign__name',
          'sales_campaign__name',
          'lead_in_date',
          'last_activity_date',
          'process_type_name',
          'process_step_name',
          'opportunity_size'
        ],
        rootType: 'AccountsCurrentStatus'
      }
    }
  },
  props: ({ tableDataQl, ownProps }) => ({
    ...ownProps,
    tableDataQl,
    tableData: tableDataQl ? tableDataQl.genericDataQuery : []
  }),
  fetchPolicy: 'no-cache'
}

const Table = genericTableFactory({
  query: qlqGenericDataQuery,
  qlOptions
})

class AccountsDetailsPopup extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    console.log('render AccountsDetailsPopup', this.props)
    return (
      <CrmModal
        isOpen={this.props.isOpen}
        title="Accounts Current Status"
        onClose={this.props.onClose}
        size="xl"
      >
        <Table
          columns={columns}
          style={{ width: '100%' }}
          filters={this.props.filters}
        />
      </CrmModal>
    )
  }
}

AccountsDetailsPopup.propTypes = {
  isOpen: bool,
  onClose: func,
  filters: shape({})
}
AccountsDetailsPopup.defaultProps = {
  isOpen: false,
  onClose: () => {},
  filters: undefined
}

export default AccountsDetailsPopup
